export interface IAjaxEntry {
  url: string;
  method: "get" | "post" | "delete";
}

export interface IAppConfig {
  jumpTo: IAjaxEntry;
  toggleError: IAjaxEntry;
  resolveError: IAjaxEntry;
  explorerContentId: string;
}

let config: IAppConfig | undefined = undefined;

function loadConfig(): IAppConfig {
  if (config !== undefined) return config;

  const scriptTag = document.getElementById("app-config")!;
  config = JSON.parse(scriptTag.innerText) as IAppConfig;
  if (!config.jumpTo || !config.toggleError) {
    throw new Error("Invalid ajax endpoints configuration");
  }
  return config;
}

export default loadConfig;
